<template>
    <PageSidebar :showError="v$.$error">
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="quit">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span>
                    {{
                        mode === "create"
                            ? $t("faq.questions.add_question")
                            : $t("faq.questions.edit_question")
                    }}
                </span>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <FormInput
                    id="questionQuestion"
                    :title="$t('faq.question')"
                    v-model="question.question"
                    @blur="v$.question.question.$touch"
                    :error="v$.question.question.$errors?.[0]?.$message"
                />
                <FormTextArea
                    id="questionAnswer"
                    :title="$t('faq.answer')"
                    v-model="question.answer"
                    :rows="10"
                    @blur="v$.question.answer.$touch"
                    :error="v$.question.answer.$errors?.[0]?.$message"
                />
            </div>
        </template>
        <template #sidebarFooter>
            <cErrorInfo v-if="v$.$error" />
            <cSaveButton
                @save="handleFormSave"
                :disabled="!isDirty"
                :ctaDisabled="$t('shared.save')"
            />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { FormInput, FormTextArea } from "@easy/ui/forms";
import { minLength, required } from "@/shared/utils/forms/i18n-vuelidators";
import { useFormValidation } from "@/shared/utils/forms/useFormValidation";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import { useIsDirty } from "@/shared/utils/forms/useIsDirty";
import cErrorInfo from "@/shared/components/cErrorInfo.vue";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        PageSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        FormInput,
        FormTextArea,
        cErrorInfo,
        cSaveButton,
    },
    props: {
        question: {
            type: Object,
            required: true,
        },
        backupData: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
    },
    emits: ["cancel", "save"],
    setup(props) {
        useFocusOnQueryField();
        const { isDirty } = useIsDirty(props.backupData, props.question);
        const { askToConfirmIfNeeded } = useSaveOrDropModal();
        const { v$, validateForm } = useFormValidation();

        return {
            isDirty,
            askToConfirmIfNeeded,
            v$,
            validateForm,
        };
    },
    validations() {
        const rules = {
            question: {
                question: { required, minLength: minLength(3) },
                answer: { required, minLength: minLength(5) },
            },
        };
        return rules;
    },
    methods: {
        async quit() {
            const result = await this.askToConfirmIfNeeded({
                showModal: this.isDirty,
                onConfirmChanges: () => this.$emit("save"),
            });
            if (!result) {
                this.$emit("cancel");
            }
        },
        async handleFormSave() {
            const isFormCorrect = await this.validateForm();

            if (isFormCorrect) {
                this.$emit("save");
            }
        },
    },
};
</script>
